import React, { useEffect, useState } from 'react'
import './AwardsAndAchievementsSection.css'
import Img1 from '../assets/images/awards/Img1.webp'
import Img2 from '../assets/images/awards/Img2.png'
import Img3 from '../assets/images/awards/Img3.png'
import Img4 from '../assets/images/awards/Img4.png'
import Img5 from '../assets/images/awards/Img5.png'

const AwardsAndAchievementsSection = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const awards = [
        {
            id: 1,
            title: 'Binghatti Award',
            category: 'Sales Excellence',
            year: '2025',
            description: 'Recognized for excellence in real estate sales and service.',
            image: Img1,
        },
        {
            id: 2,
            title: 'Shahrukhz by Danube Competition',
            category: 'Sales Excellence',
            year: '2025',
            description: 'Recognition for outstanding performance in a competitive sales campaign.',
            image: Img2,
        },
        {
            id: 3,
            title: '1% Elite Broker Award by Danube',
            category: 'Elite Recognition',
            year: '2025',
            description: "Top-performing broker for Danube Properties' off-plan sales in 2025.",
            image: Img3,
        },
        {
            id: 4,
            title: 'Gulf Achievers Award 2025',
            category: 'Regional Excellence',
            year: '2025',
            description: 'Regional recognition for excellence in Gulf real estate.',
            image: Img4,
        },

        {
            id: 5,
            title: 'The Asian Arab Business Awards 2025',
            category: 'Excellence & Innovation',
            year: '2025',
            description: 'Honouring innovation and client service in the property sector.',
            image: Img5,
        },
    ]

    const [currentSlide, setCurrentSlide] = useState(0)
    const [awardsPerSlide, setAwardsPerSlide] = useState(3)
    const [autoPlay, setAutoPlay] = useState(true)
    const totalSlides = awards.length - awardsPerSlide + 1

    useEffect(() => {
        const handleResize = () => {
            setAwardsPerSlide(window.innerWidth >= 768 ? 3 : 1)
        }

        handleResize()
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    useEffect(() => {
        setCurrentSlide(0)
    }, [awardsPerSlide])

    // Auto-play effect
    useEffect(() => {
        if (!autoPlay) return

        const interval = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % totalSlides)
        }, 5000)

        return () => clearInterval(interval)
    }, [autoPlay, totalSlides])

    const goToSlide = (index) => {
        setCurrentSlide(index)
        setAutoPlay(false)
        setTimeout(() => setAutoPlay(true), 7000)
    }

    return (
        <>
            {/* Awards Carousel */}
            <section className="awards-section container-fluid">
                <div className="awards-heading text-center">
                    <div className="text-ss-primary fs-ss-14 fw-500">Recent Recognition</div>
                    <h2 className="text-white fs-ss-35 fw-600 lh-sm">Prestigious Awards</h2>
                    <p className="awards-intro text-white fs-ss-15 fw-300">
                        Developer sales awards and regional recognition. Add industry accolades here, e.g. Bayut /
                        dubizzle Agency of the Year categories.
                    </p>
                </div>

                <div
                    className="awards-carousel position-relative"
                    onMouseEnter={() => setAutoPlay(false)}
                    onMouseLeave={() => setAutoPlay(true)}
                >
                    <div className="row g-0 awards-grid">
                        {awards.slice(currentSlide, currentSlide + awardsPerSlide).map((award, index) => (
                                <div
                                    key={award.id}
                                    className={`col-12 ${awardsPerSlide === 3 ? 'col-md-4' : ''}`}
                                >
                                    <article className={`awards-card ${index > 0 && awardsPerSlide === 3 ? 'awards-card-divided' : ''}`}>
                                        <div className="awards-image-wrap">
                                            <img src={award.image} alt={award.title} loading="lazy" />
                                        </div>
                                        <div className="awards-card-content">
                                            <h3>{award.title}</h3>
                                            <p>{award.description}</p>
                                            <div className="awards-badges">
                                                <span className="awards-category">{award.category}</span>
                                                <span className="awards-year">{award.year}</span>
                                            </div>
                                        </div>
                                    </article>
                                </div>
                            ))}
                    </div>

                    {totalSlides > 1 && (
                        <div className="awards-dots text-center">
                            {Array.from({ length: totalSlides }).map((_, index) => (
                                <button
                                    key={index}
                                    onClick={() => goToSlide(index)}
                                    aria-label={`Show awards ${index + 1}`}
                                    aria-current={currentSlide === index ? 'true' : undefined}
                                    className={currentSlide === index ? 'is-active' : ''}
                                />
                            ))}
                        </div>
                    )}
                </div>
            </section>
        </>
    )
}

export default AwardsAndAchievementsSection
